<template>
  <div class="wrap">
    <div class="board">
      <ContentsTitle></ContentsTitle>
      <ContentsInner @move-content="moveContent"></ContentsInner>
      <div class="Modals">
        <ModalAlert
          :alertMsg="errMsg"
          :isOpen="errStatus"
          @update:isOpen="updateStatus"
        ></ModalAlert>
      </div>
      <!-- <ContentsNotice></ContentsNotice> -->
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

import ContentsTitle from '../components/ContentsTitle.vue'
import ContentsInner from '../components/ContentsInner.vue'
// import ContentsNotice from '../components/ContentsNotice.vue'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'ContentDetailViews',
  components: {
    ContentsTitle,
    ContentsInner,
    // ContentsNotice,
    ModalAlert,
  },
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)
    // console.log(errMsg, errStatus);
    const moveContent = (alertMsg) => {
      errStatus.value = true
      errMsg.value = alertMsg
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    return {
      errMsg,
      errStatus,
      moveContent,
      updateStatus,
    }
  },
}
</script>
